import { QueryObserverBaseResult, useQuery } from "react-query";
import { queryKeys } from "../../query";
import api from "../../client";
import { ContactPlatformListResponseData } from "../../types/enum";

export const getData = async () => {
  const { data } =
    await api.get<ContactPlatformListResponseData>(`/contact-platforms`);

  return data;
};

export const useContactPlatforms =
  (): QueryObserverBaseResult<ContactPlatformListResponseData> => {
    const { data, ...props } = useQuery(queryKeys.contactPlatforms(), () =>
      getData(),
    );

    return { data, ...props };
  };
